import axios from 'axios';

const baseURL = process.env.REACT_APP_API_BASE_URL || '/api';

const api = axios.create({
  baseURL,
});

// При каждом запросе подставляем access-токен
api.interceptors.request.use(
  config => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

let isRefreshing = false;
let failedQueue = [];

// Разобрать отложенные запросы после рефреша
const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    error ? prom.reject(error) : prom.resolve(token);
  });
  failedQueue = [];
};

api.interceptors.response.use(
  response => response,
  err => {
    const { config, response } = err;
    const originalRequest = config;

    // если не 401 или уже пытались рефрешиться ― просто прокидываем
    if (response?.status !== 401 || originalRequest._retry) {
      return Promise.reject(err);
    }

    originalRequest._retry = true;

    if (isRefreshing) {
      // ставим в очередь и дождёмся
      return new Promise((resolve, reject) => {
        failedQueue.push({ resolve, reject });
      })
        .then(token => {
          originalRequest.headers.Authorization = `Bearer ${token}`;
          return api(originalRequest);
        })
        .catch(e => Promise.reject(e));
    }

    isRefreshing = true;
    const refreshToken = localStorage.getItem('refreshToken');

    // Отправляем запрос на обновление
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseURL}/token/refresh/`, { refresh: refreshToken })
        .then(({ data }) => {
          const newAccess = data.access;
          localStorage.setItem('accessToken', newAccess);
          api.defaults.headers.Authorization = `Bearer ${newAccess}`;
          originalRequest.headers.Authorization = `Bearer ${newAccess}`;
          processQueue(null, newAccess);
          resolve(api(originalRequest));
        })
        .catch(error => {
          processQueue(error, null);
          reject(error);
        })
        .finally(() => {
          isRefreshing = false;
        });
    });
  }
);

// Примеры ваших экспортируемых методов — они остались без изменений
export const getTasks = async () => {
  const response = await api.get('/tasks/');
  return response.data;
};

export const createTask = async task => {
  const response = await api.post('/tasks/', task);
  return response.data;
};

console.log('Axios baseURL:', baseURL);
export default api;
